import React from 'react'
import SkeletonLoder from '../common/skeletonLoder';
import PropTypes from "prop-types";
import { DropDownWrapper } from '../../containers/Education/styles';
import { DropdownContent } from '../UserDashboard/styles';
import {ImageUrl} from '../../utils/constants';
import { Heading } from './style';
import { useEffect } from 'react';
import { FlexWrapper, NewChampionsCardNew,EventCard, NewVideoPlayerNew, NewContentV2New} from '../MainEvents/RecommendEventVideos/styles'
import Thumbnail from '../Thumbnail';
import { fetchApi } from '../../utils/methods';
import { toast } from 'react-toastify';
import { ArchiveFitness, GetLaunchedFitness } from '../../redux/constants/apiConstants';
import { useHistory } from "react-router-dom";
import { ArchiveCategoryIcon, EditIconNew } from '../../utils/icons';
import CommonModalNew from '../common/CommonModal/CommonModalNew';


function FitnessComponent({categories,wellnessLoading}) {
  const history = useHistory();
  const [launchedFitness, setLaunchedFitness,] = React.useState([]);
  const [archivePopupOpen, setArchivePopupOpen] = React.useState(false);
  const [selectedArticle, setSelectedArticle] = React.useState(null);

  useEffect(()=>{
    FetchRecentLaunchedData();
  },[])
  
  
  const FetchRecentLaunchedData = async()=>{
    try {
      const res = await fetchApi(GetLaunchedFitness, "GET");
      if(res.status === 'success'){
        setLaunchedFitness(res.data[0].data)
      }else{
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }


  const ArchiveCatgories = async()=>{
    const categoryId = selectedArticle?.fitness_id;
    
    try {
      const res = await fetchApi(ArchiveFitness + "/" + categoryId, "DELETE");
      if(res.status === 'success'){
        toast.success(res.message);
        FetchRecentLaunchedData();  
        setLaunchedFitness(res.data[0].data);
       
       
      }else{
        toast.error((res?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }
  
  const handleArchivePopup = (item) => {
    setArchivePopupOpen(true);
    setSelectedArticle(item);
  }

  const handleArchivePopupClose = () => {
    setArchivePopupOpen(false);
  }

  
  
  const handleConfirmArchive = () => {
    ArchiveCatgories();
    setArchivePopupOpen(false);
  }
  

  const handleFitnessClick = (item) => {
    history.push({pathname:`/education/videos-library/${item.fitness_id}`,state : {libraryPage:"Fitness"}});
  };



  const handleEdit = (id) => {
    history.push({
      pathname: `/education/videos-library/edit/${id}`,
      state: { page: "Fitness" }
    });
  }; 


  return (
    <div>


      {wellnessLoading ? <SkeletonLoder width="1248px" height="100px" style={{ marginTop:"20px" }} /> : categories?.length ? <DropDownWrapper>
        {categories?.map((data, index) => (
          <DropdownContent key={index} /*onClick={() => history.push({pathname:`/wellness-resources/${data?.type}`,state:{categoryData:data}})}*/
            onClick={() => history.push({pathname:`/company/wellness/category-content`,state:{categoryData:data,contentType: "fitness"}})}>
            <img src={`${ImageUrl}/${data?.image}`} />
            <div className="listContent">{data?.category_name}</div>
          </DropdownContent>))}
      </DropDownWrapper> : null}


      <Heading>Recently Launched Fitness Videos</Heading>

      <FlexWrapper>
        {launchedFitness
          .map((item) => (
            <NewChampionsCardNew key={item.fitness_id} >
              <EventCard isMarginBottom={"0px"} borderRadius={"6px 6px 0 0"} isWidth={"398px"}>
                  
                <NewVideoPlayerNew onClick={() => handleFitnessClick(item)}  style={{ cursor: 'pointer' }}>
                  <Thumbnail
                    style={{ cursor: 'pointer',marginTop:"8px" }} 
                    src={`${ImageUrl}/${item?.thumbnail_image}`}
                    alt={'img'}
                  />
                </NewVideoPlayerNew>
                <NewContentV2New newPadding={'newPadding'} isPadding={"16px 8px 8px 8px"}  style={{ minHeight: 'auto',backgroundColor:"#FEFEFE",borderRadius:'0px 0px 8px 8px' }}>
                  <div className='firstContainer'>
                    <div className='name' title={item?.title}>
                      {item?.title}
                    </div>
                  </div>
                  <div className="imageContainer">
                    <span
                      className="icon archive"
                      onClick={() => handleArchivePopup(item)}
                      title="Archive"
                    >
                      {ArchiveCategoryIcon()}
                    </span>
                    <span
                      className="icon edit"
                      onClick={() => handleEdit(item.fitness_id)}
                      title="Edit"
                    >
                      {EditIconNew()}
                    </span>
                  </div>
                </NewContentV2New>
              </EventCard>
            </NewChampionsCardNew>
          ))}
      </FlexWrapper>

      {archivePopupOpen && <CommonModalNew
        show={archivePopupOpen}
        icon={ArchiveCategoryIcon("#184A61")}
        title="Archive Video"
        description="Are you sure you want to Archive this video?"
        subDescription="You can view the archived data in archive tab of wellness resources"
        onCancel={handleArchivePopupClose}
        onConfirm={handleConfirmArchive}
        cancelText="Keep Video"
        confirmButtonText="Archive"
        buttonIcon={ArchiveCategoryIcon("white")}
        modalHeight="261px"
        confirmButtonWidth="200px"
      />}
      
      
    </div>
  )
}

FitnessComponent.propTypes={
  wellnessLoading: PropTypes.bool.isRequired,
  categories: PropTypes.array.isRequired

}


export default FitnessComponent;
